module.exports = __webpack_public_path__ + "static/media/wide.b00839d9.jpg";